// Application Form 相关的翻译资源
export const applicationFormResources = {
  zh: {
    "common.close": "关闭",
    
    "applicationForm.title": "博士生育儿补助申请表",
    "applicationForm.subtitle": "补助为一次性资助，适用于香港全日制在读博士生，且子女须于 2026 年 1 月 1 日或之后出生",
    "applicationForm.warning": "申请通道将于 2026 年 1 月 1 日开放，当前阶段您可先行浏览与准备材料",
    "applicationForm.validationError": "请根据提示，修改内容后重新提交",
    
    "applicationForm.fields.name.label": "姓名",
    "applicationForm.fields.name.placeholder": "请填入您的全名",
    "applicationForm.fields.name.hint": "与学生证姓名一致",
    "applicationForm.fields.name.required": "请输入您的全名",
    
    "applicationForm.fields.email.label": "电邮地址",
    "applicationForm.fields.email.placeholder": "you@example.com",
    "applicationForm.fields.email.hint": "用于通知及后续联系",
    "applicationForm.fields.email.required": "请输入有效的电邮地址",
    
    "applicationForm.fields.phone.label": "电话号码",
    "applicationForm.fields.phone.placeholder": "输入电话号码",
    "applicationForm.fields.phone.hint": "用于后续联系",
    "applicationForm.fields.phone.required": "请输入您的电话号码",
    
    "applicationForm.fields.university.label": "大学名称",
    "applicationForm.fields.university.placeholder": "输入您的大学名称",
    "applicationForm.fields.university.hint": "您需要是香港全日制在读博士生",
    "applicationForm.fields.university.required": "请输入大学名称",
    
    "applicationForm.fields.researchProject.label": "研究项目名称",
    "applicationForm.fields.researchProject.placeholder": "e.g. PhD in Sociology",
    "applicationForm.fields.researchProject.hint": "记录课程名称及领域",
    "applicationForm.fields.researchProject.required": "请输入研究项目名称",
    
    "applicationForm.fields.childBirthDate.label": "子女出生日期",
    "applicationForm.fields.childBirthDate.placeholder": "年/月/日",
    "applicationForm.fields.childBirthDate.hint": "子女须于 2026-01-01 以后出生",
    "applicationForm.fields.childBirthDate.required": "请选择子女出生日期",
    
    "applicationForm.fields.studentId.label": "上传学生证",
    "applicationForm.fields.studentId.uploadText1": "点击上传或拖放",
    "applicationForm.fields.studentId.uploadText2": "支持格式：pdf，jpg，jpeg，png（最大5MB）",
    "applicationForm.fields.studentId.uploadText3": "选择文件",
    "applicationForm.fields.studentId.hint": "学生证须含：姓名、相片、学号、课程、注册年份",
    "applicationForm.fields.studentId.required": "请上传学生证",
    "applicationForm.fields.maxFiles": "最多上传10个文件",
    
    "applicationForm.fields.enrollmentCert.label": "上传学校成绩单/在读证明",
    "applicationForm.fields.enrollmentCert.uploadText1": "点击上传或拖放",
    "applicationForm.fields.enrollmentCert.uploadText2": "支持格式：pdf，jpg，jpeg，png（最大5MB）",
    "applicationForm.fields.enrollmentCert.uploadText3": "选择文件",
    "applicationForm.fields.enrollmentCert.hint": "须包括姓名、学号、发出日期",
    "applicationForm.fields.enrollmentCert.required": "请上传学校成绩单/在读证明",
    
    "applicationForm.fields.birthCert.label": "上传子女出生证明",
    "applicationForm.fields.birthCert.uploadText1": "点击上传或拖放",
    "applicationForm.fields.birthCert.uploadText2": "支持格式：pdf，jpg，jpeg，png（最大5MB）",
    "applicationForm.fields.birthCert.uploadText3": "选择文件",
    "applicationForm.fields.birthCert.hint": "包含父母姓名、子女出生日期及地点",
    "applicationForm.fields.birthCert.required": "请上传子女出生证明",
    
    "applicationForm.fields.bankInfo.title": "银行账户信息",
    "applicationForm.fields.bankInfo.bankName.placeholder": "e.g.The Hongkong and Shanghai Banking Corporation Limited",
    "applicationForm.fields.bankInfo.bankName.hint": "银行名称",
    "applicationForm.fields.bankInfo.bankName.required": "请输入银行名称",
    
    "applicationForm.fields.bankInfo.accountHolder.placeholder": "e.g.ZHANG San（请使用大写拼音，与银行记录严格一致）",
    "applicationForm.fields.bankInfo.accountHolder.hint": "账户持有人姓名",
    "applicationForm.fields.bankInfo.accountHolder.required": "请输入账户持有人姓名",
    
    "applicationForm.fields.bankInfo.accountNumber.placeholder": "e.g.123-456789-838",
    "applicationForm.fields.bankInfo.accountNumber.hint": "银行账户账号",
    "applicationForm.fields.bankInfo.accountNumber.required": "请输入银行账户账号",
    
    "applicationForm.fields.interviewWillingness.label": "访谈意愿",
    "applicationForm.fields.interviewWillingness.description": "本基金会致力于扶贫与教育推广、促进生育及向公众推广共建家庭友善社会的认知，您的参与对我们来说意义非凡，现诚挚邀请您参加我们的访谈，与大家分享您对基金会在育儿津贴工作上的看法",
    "applicationForm.fields.interviewWillingness.agree": "同意",
    "applicationForm.fields.interviewWillingness.disagree": "不同意",
    "applicationForm.fields.interviewWillingness.required": "请选择访谈意愿",
    
    "applicationForm.fields.agreeTerms.label": "确认声明",
    "applicationForm.fields.agreeTerms.hint": "我确认符合申请资格，并保证所填资料真实准确",
    "applicationForm.fields.agreeTerms.required": "请确认声明",
    
    "applicationForm.fields.agreePrivacy.label": "个人资料使用授权",
    "applicationForm.fields.agreePrivacy.hint": "我同意创生基金使用上述提供的资料(包括敏感个人资料)来评估我的申请并发放补贴,并将这些资料与必要的第三方分享以进行验证。请参见 隐私政策以获取详细信息",
    "applicationForm.fields.agreePrivacy.required": "请确认个人资料使用授权",
    
    "applicationForm.submitButton": "立即提交",
    "applicationForm.submitting": "提交中...",
    "applicationForm.submitSuccess": "提交成功",
    "applicationForm.submitSuccess.message": "我们团队将在14个工作日内审核您的资料。请留意邮箱,以便及时接收审核进展的通知。",
    "applicationForm.submitSuccess.button": "知道了",
    "applicationForm.submitError": "提交失败",
    "applicationForm.submitError.message": "很抱歉,系统暂时无法完成提交。请稍候再试。",
    "applicationForm.submitError.retry": "重试",
    "applicationForm.submitError.back": "返回"
  },
  zh_TW: {
    "common.close": "關閉",
    
    "applicationForm.title": "博士生育兒補助申請表",
    "applicationForm.subtitle": "補助為一次性資助，適用於香港全日制在讀博士生，且子女須於 2026 年 1 月 1 日或之後出生",
    "applicationForm.warning": "申請通道將於 2026 年 1 月 1 日開放，當前階段您可先行瀏覽與準備材料",
    "applicationForm.validationError": "請根據提示，修改內容後重新提交",
    
    "applicationForm.fields.name.label": "姓名",
    "applicationForm.fields.name.placeholder": "請填入您的全名",
    "applicationForm.fields.name.hint": "與學生證姓名一致",
    "applicationForm.fields.name.required": "請輸入您的全名",
    
    "applicationForm.fields.email.label": "電郵地址",
    "applicationForm.fields.email.placeholder": "you@example.com",
    "applicationForm.fields.email.hint": "用於通知及後續聯繫",
    "applicationForm.fields.email.required": "請輸入有效的電郵地址",
    
    "applicationForm.fields.phone.label": "電話號碼",
    "applicationForm.fields.phone.placeholder": "輸入電話號碼",
    "applicationForm.fields.phone.hint": "用於後續聯繫",
    "applicationForm.fields.phone.required": "請輸入您的電話號碼",
    
    "applicationForm.fields.university.label": "大學名稱",
    "applicationForm.fields.university.placeholder": "輸入您的大學名稱",
    "applicationForm.fields.university.hint": "僅香港全日制在讀博士生可申請",
    "applicationForm.fields.university.required": "請輸入大學名稱",
    
    "applicationForm.fields.researchProject.label": "研究項目名稱",
    "applicationForm.fields.researchProject.placeholder": "e.g. PhD in Sociology",
    "applicationForm.fields.researchProject.hint": "記錄課程名稱及領域",
    "applicationForm.fields.researchProject.required": "請輸入研究項目名稱",
    
    "applicationForm.fields.childBirthDate.label": "子女出生日期",
    "applicationForm.fields.childBirthDate.placeholder": "年/月/日",
    "applicationForm.fields.childBirthDate.hint": "子女須於 2026-01-01 以後出生",
    "applicationForm.fields.childBirthDate.required": "請選擇子女出生日期",
    
    "applicationForm.fields.studentId.label": "上傳學生證",
    "applicationForm.fields.studentId.uploadText1": "點擊上傳或拖放",
    "applicationForm.fields.studentId.uploadText2": "支持格式：pdf，jpg，jpeg，png（最大5MB）",
    "applicationForm.fields.studentId.uploadText3": "選擇檔案",
    "applicationForm.fields.studentId.hint": "學生證須含：姓名、相片、學號、課程、註冊年份",
    "applicationForm.fields.studentId.required": "請上傳學生證",
    "applicationForm.fields.maxFiles": "最多上傳10個檔案",
    
    "applicationForm.fields.enrollmentCert.label": "上傳學校成績單/在讀證明",
    "applicationForm.fields.enrollmentCert.uploadText1": "點擊上傳或拖放",
    "applicationForm.fields.enrollmentCert.uploadText2": "支持格式：pdf，jpg，jpeg，png（最大5MB）",
    "applicationForm.fields.enrollmentCert.uploadText3": "選擇檔案",
    "applicationForm.fields.enrollmentCert.hint": "須包括姓名、學號、發出日期",
    "applicationForm.fields.enrollmentCert.required": "請上傳學校成績單/在讀證明",
    
    "applicationForm.fields.birthCert.label": "上傳子女出生證明",
    "applicationForm.fields.birthCert.uploadText1": "點擊上傳或拖放",
    "applicationForm.fields.birthCert.uploadText2": "支持格式：pdf，jpg，jpeg，png（最大5MB）",
    "applicationForm.fields.birthCert.uploadText3": "選擇檔案",
    "applicationForm.fields.birthCert.hint": "包含父母姓名、子女出生日期及地點",
    "applicationForm.fields.birthCert.required": "請上傳子女出生證明",
    
    "applicationForm.fields.bankInfo.title": "銀行賬戶資訊",
    "applicationForm.fields.bankInfo.bankName.placeholder": "e.g.The Hongkong and Shanghai Banking Corporation Limited",
    "applicationForm.fields.bankInfo.bankName.hint": "銀行名稱",
    "applicationForm.fields.bankInfo.bankName.required": "請輸入銀行名稱",
    
    "applicationForm.fields.bankInfo.accountHolder.placeholder": "e.g.ZHANG San（請使用大寫拼音，與銀行記錄嚴格一致）",
    "applicationForm.fields.bankInfo.accountHolder.hint": "賬戶持有人姓名",
    "applicationForm.fields.bankInfo.accountHolder.required": "請輸入賬戶持有人姓名",
    
    "applicationForm.fields.bankInfo.accountNumber.placeholder": "e.g.123-456789-838",
    "applicationForm.fields.bankInfo.accountNumber.hint": "銀行賬戶賬號",
    "applicationForm.fields.bankInfo.accountNumber.required": "請輸入銀行賬戶賬號",
    
    "applicationForm.fields.interviewWillingness.label": "訪談意願",
    "applicationForm.fields.interviewWillingness.description": "本基金會致力於扶貧與教育推廣、促進生育及向公眾推廣共建家庭友善社會的認知，您的參與對我們來說意義非凡，現誠摯邀請您參加我們的訪談，與大家分享您對基金會在育兒津貼工作上的看法",
    "applicationForm.fields.interviewWillingness.agree": "同意",
    "applicationForm.fields.interviewWillingness.disagree": "不同意",
    "applicationForm.fields.interviewWillingness.required": "請選擇訪談意願",
    
    "applicationForm.fields.agreeTerms.label": "確認聲明",
    "applicationForm.fields.agreeTerms.hint": "我確認符合申請資格，並保證所填資料真實準確",
    "applicationForm.fields.agreeTerms.required": "請確認聲明",
    
    "applicationForm.fields.agreePrivacy.label": "個人資料使用授權",
    "applicationForm.fields.agreePrivacy.hint": "我同意創生基金使用上述提供的資料(包括敏感個人資料)來評估我的申請並發放補貼,並將這些資料與必要的第三方分享以進行驗證。請參見 隱私政策以獲取詳細信息",
    "applicationForm.fields.agreePrivacy.required": "請確認個人資料使用授權",
    
    "applicationForm.submitButton": "立即提交",
    "applicationForm.submitting": "提交中...",
    "applicationForm.submitSuccess": "提交成功",
    "applicationForm.submitSuccess.message": "我們團隊將在14個工作日內審核您的資料。請留意郵箱,以便及時接收審核進展的通知。",
    "applicationForm.submitSuccess.button": "知道了",
    "applicationForm.submitError": "提交失敗",
    "applicationForm.submitError.message": "很抱歉,系統暫時無法完成提交。請稍候再試。",
    "applicationForm.submitError.retry": "重試",
    "applicationForm.submitError.back": "返回"
  },
  en: {
    "common.close": "Close",
    
    "applicationForm.title": "PhD Student Childcare Subsidy Application",
    "applicationForm.subtitle": "This is a one-time subsidy for full-time PhD students in Hong Kong, and the child must be born on or after January 1, 2026",
    "applicationForm.warning": "Application portal will open on January 1, 2026. You may browse and prepare materials in advance",
    "applicationForm.validationError": "Please revise the content according to the instructions and resubmit",
    
    "applicationForm.fields.name.label": "Name",
    "applicationForm.fields.name.placeholder": "Please enter your full name",
    "applicationForm.fields.name.hint": "Must match the name on student ID",
    "applicationForm.fields.name.required": "Please enter your full name",
    
    "applicationForm.fields.email.label": "Email Address",
    "applicationForm.fields.email.placeholder": "you@example.com",
    "applicationForm.fields.email.hint": "For notifications and follow-up contact",
    "applicationForm.fields.email.required": "Please enter a valid email address",
    
    "applicationForm.fields.phone.label": "Phone Number",
    "applicationForm.fields.phone.placeholder": "Enter phone number",
    "applicationForm.fields.phone.hint": "For follow-up contact",
    "applicationForm.fields.phone.required": "Please enter your phone number",
    
    "applicationForm.fields.university.label": "University Name",
    "applicationForm.fields.university.placeholder": "Enter your university name",
    "applicationForm.fields.university.hint": "You must be a full-time PhD student in Hong Kong",
    "applicationForm.fields.university.required": "Please enter university name",
    
    "applicationForm.fields.researchProject.label": "Research Project Name",
    "applicationForm.fields.researchProject.placeholder": "e.g. PhD in Sociology",
    "applicationForm.fields.researchProject.hint": "Record the course name and field",
    "applicationForm.fields.researchProject.required": "Please enter research project name",
    
    "applicationForm.fields.childBirthDate.label": "Child's Birth Date",
    "applicationForm.fields.childBirthDate.placeholder": "Year/Month/Day",
    "applicationForm.fields.childBirthDate.hint": "Child must be born on or after 2026-01-01",
    "applicationForm.fields.childBirthDate.required": "Please select child's birth date",
    
    "applicationForm.fields.studentId.label": "Upload Student ID",
    "applicationForm.fields.studentId.uploadText1": "Click to upload or drag and drop",
    "applicationForm.fields.studentId.uploadText2": "Supported formats: pdf, jpg, jpeg, png (Max 5MB)",
    "applicationForm.fields.studentId.uploadText3": "Select File",
    "applicationForm.fields.studentId.hint": "Student ID must include: Name, Photo, Student Number, Course, Registration Year",
    "applicationForm.fields.studentId.required": "Please upload student ID",
    "applicationForm.fields.maxFiles": "Maximum 10 files",
    
    "applicationForm.fields.enrollmentCert.label": "Upload School Transcript/Enrollment Certificate",
    "applicationForm.fields.enrollmentCert.uploadText1": "Click to upload or drag and drop",
    "applicationForm.fields.enrollmentCert.uploadText2": "Supported formats: pdf, jpg, jpeg, png (Max 5MB)",
    "applicationForm.fields.enrollmentCert.uploadText3": "Select File",
    "applicationForm.fields.enrollmentCert.hint": "Must include name, student number, issue date",
    "applicationForm.fields.enrollmentCert.required": "Please upload school transcript/enrollment certificate",
    
    "applicationForm.fields.birthCert.label": "Upload Child's Birth Certificate",
    "applicationForm.fields.birthCert.uploadText1": "Click to upload or drag and drop",
    "applicationForm.fields.birthCert.uploadText2": "Supported formats: pdf, jpg, jpeg, png (Max 5MB)",
    "applicationForm.fields.birthCert.uploadText3": "Select File",
    "applicationForm.fields.birthCert.hint": "Must include parent names, child's birth date and place",
    "applicationForm.fields.birthCert.required": "Please upload child's birth certificate",
    
    "applicationForm.fields.bankInfo.title": "Bank Account Information",
    "applicationForm.fields.bankInfo.bankName.placeholder": "e.g.The Hongkong and Shanghai Banking Corporation Limited",
    "applicationForm.fields.bankInfo.bankName.hint": "Bank name",
    "applicationForm.fields.bankInfo.bankName.required": "Please enter bank name",
    
    "applicationForm.fields.bankInfo.accountHolder.placeholder": "e.g.ZHANG San (use uppercase pinyin, must match bank records exactly)",
    "applicationForm.fields.bankInfo.accountHolder.hint": "Account holder name",
    "applicationForm.fields.bankInfo.accountHolder.required": "Please enter account holder name",
    
    "applicationForm.fields.bankInfo.accountNumber.placeholder": "e.g.123-456789-838",
    "applicationForm.fields.bankInfo.accountNumber.hint": "Bank account number",
    "applicationForm.fields.bankInfo.accountNumber.required": "Please enter bank account number",
    
    "applicationForm.fields.interviewWillingness.label": "Interview willingness",
    "applicationForm.fields.interviewWillingness.description": "Our mission is to facilitate poverty alleviation and educational advancement, promote childbirth, and enhance family-friendly social awareness. To further this mission, we sincerely invite you to participate in an interview as part of our program and share your views on the foundation’s work in providing childcare subsidies.",
    "applicationForm.fields.interviewWillingness.agree": "Agree",
    "applicationForm.fields.interviewWillingness.disagree": "Disagree",
    "applicationForm.fields.interviewWillingness.required": "Please select your interview willingness",
    
    "applicationForm.fields.agreeTerms.label": "Confirmation Statement",
    "applicationForm.fields.agreeTerms.hint": "I confirm that I meet the eligibility requirements and guarantee that the information provided is true and accurate",
    "applicationForm.fields.agreeTerms.required": "Please confirm the statement",
    
    "applicationForm.fields.agreePrivacy.label": "Personal Information Usage Authorization",
    "applicationForm.fields.agreePrivacy.hint": "I agree that Genovation Foundation may use the information provided above (including sensitive personal information) to evaluate my application and issue subsidies, and share this information with necessary third parties for verification. Please refer to the Privacy Policy for detailed information",
    "applicationForm.fields.agreePrivacy.required": "Please confirm personal information usage authorization",
    
    "applicationForm.submitButton": "Apply Now",
    "applicationForm.submitting": "Submitting...",
    "applicationForm.submitSuccess": "Submission Successful",
    "applicationForm.submitSuccess.message": "Our team will review your information within 14 working days. Please check your email to receive timely notifications of the review progress.",
    "applicationForm.submitSuccess.button": "Got it",
    "applicationForm.submitError": "Submission Failed",
    "applicationForm.submitError.message": "Sorry, the system is temporarily unable to complete the submission. Please try again later.",
    "applicationForm.submitError.retry": "Retry",
    "applicationForm.submitError.back": "Back"
  }
};

